export default "__VITE_ASSET__v_YCk7Ys__"